import ImagesMainBannerAlwaysOnHandAlwaysOnHandBgWebp from '@/public/images/main-banner/always-on-hand/always-on-hand-bg.webp';
import ImagesMainBannerAlwaysOnHandAlwaysOnHandPersonWebp from '@/public/images/main-banner/always-on-hand/always_on_hand_person.webp';
import ImagesMainBannerAlwaysOnHandAlwaysOnHandSpiritoryAppWebp from '@/public/images/main-banner/always-on-hand/always-on-hand-spiritory-app.webp';
import ImagesMainBannerAlwaysOnHandAlwaysOnHandSpiritoryIconSvg from '@/public/images/main-banner/always-on-hand/always-on-hand-spiritory-icon.svg';
import ImagesMainBannerAlwaysOnHandAppStoreTextSvg from '@/public/images/main-banner/always-on-hand/AppStoreText.svg';
import ImagesMainBannerAlwaysOnHandAppleSvg from '@/public/images/main-banner/always-on-hand/Apple.svg';
import ImagesMainBannerAlwaysOnHandGooglePlayTextSvg from '@/public/images/main-banner/always-on-hand/GooglePlayText.svg';
import ImagesMainBannerAlwaysOnHandPlaystoreSvg from '@/public/images/main-banner/always-on-hand/Playstore.svg';

export {
  ImagesMainBannerAlwaysOnHandAlwaysOnHandBgWebp,
  ImagesMainBannerAlwaysOnHandAlwaysOnHandPersonWebp,
  ImagesMainBannerAlwaysOnHandAlwaysOnHandSpiritoryAppWebp,
  ImagesMainBannerAlwaysOnHandAlwaysOnHandSpiritoryIconSvg,
  ImagesMainBannerAlwaysOnHandAppStoreTextSvg,
  ImagesMainBannerAlwaysOnHandAppleSvg,
  ImagesMainBannerAlwaysOnHandGooglePlayTextSvg,
  ImagesMainBannerAlwaysOnHandPlaystoreSvg,
};
